/** @format */

import posthog from 'posthog-js'
import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'

export type PosthogContextType = typeof posthog | null

export const PosthogContext = createContext<PosthogContextType>(null)

export const PosthogContextProvider = ({children}: PropsWithChildren) => {
  const [posthogInstance, setPosthogInstance] = useState<typeof posthog | null>(
    null,
  )

  useEffect(() => {
    // Check if posthog already exists on window
    if ((window as any).posthog) {
      setPosthogInstance((window as any).posthog)
      return
    }

    // Initialize posthog if it doesn't exist
    const posthogToken = (window as any)?.formspree?.POSTHOG_FRONTEND_TOKEN

    if (posthogToken) {
      posthog.init(posthogToken, {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'always',
      })

      // Make it globally available
      ;(window as any).posthog = posthog

      setPosthogInstance(posthog)
    }
  }, [])

  return (
    <PosthogContext.Provider value={posthogInstance}>
      {children}
    </PosthogContext.Provider>
  )
}

export function usePosthog(): PosthogContextType {
  return useContext(PosthogContext)
}
